export default __webpack_public_path__ + "static/product-presentation-KZ-94151a4defe4066fd7afa126517ee913.png";